import { curveMonotoneX } from "@visx/curve";
import { LinePath } from "@visx/shape";
import { InfraEventPassengerCount } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import {
  getDate,
  getValue,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/utils";
import type { FC } from "react";
import type {
  DateScale,
  ValueScale,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";

type ChosenStretchLineProps = {
  data: InfraEventPassengerCount[];
  dateScale: DateScale;
  valueScale: ValueScale;
  strokeColor: string;
};

export const ChosenStretchLine: FC<ChosenStretchLineProps> = ({
  data,
  dateScale,
  valueScale,
  strokeColor,
}) => {
  if (!data.length) return null;

  return (
    <LinePath
      data={data}
      x={(d) => dateScale(getDate(d))}
      y={(d) => valueScale(getValue(d))}
      stroke={strokeColor}
      strokeWidth={2}
      curve={curveMonotoneX}
    />
  );
};
